import(/* webpackMode: "eager" */ "/vercel/path0/src/components/footprint/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/center-layout.tsx")